import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { DriverAdminTabs } from '../../components/admin/DriverAdminTabs';
import { Car, Plus, Phone, CheckCircle2, XCircle, Loader2, Search, Users, Link as LinkIcon, IdCard } from 'lucide-react';
interface Driver {
  id: number;
  full_name: string;
  national_id: string | null;
  phone: string;
  is_active: boolean;
  created_at: string;
  active_vehicle?: any;
}
export function DriversListPage() {
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState<Driver[]>([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  useEffect(() => {
    fetchDrivers();
  }, []);
  const fetchDrivers = async () => {
    setLoading(true);
    const {
      data: driversData,
      error
    } = await supabase.from('drivers').select('id, full_name, national_id, phone, is_active, created_at').order('created_at', {
      ascending: false
    });
    if (!error && driversData) {
      const driversWithVehicles = await Promise.all(driversData.map(async driver => {
        try {
          const {
            data: vehicleData
          } = await supabase.rpc('get_active_vehicle_for_driver', {
            p_driver_id: driver.id
          });
          return {
            ...driver,
            active_vehicle: Array.isArray(vehicleData) ? vehicleData[0] : vehicleData
          };
        } catch (err) {
          return driver;
        }
      }));
      setDrivers(driversWithVehicles);
    }
    setLoading(false);
  };
  const toggleActive = async (driverId: number, currentStatus: boolean) => {
    await supabase.from('drivers').update({
      is_active: !currentStatus
    }).eq('id', driverId);
    fetchDrivers();
  };
  const filtered = drivers.filter(d => d.full_name?.toLowerCase().includes(search.toLowerCase()) || d.phone?.includes(search) || d.national_id?.toLowerCase().includes(search.toLowerCase()));
  return <div className="min-h-screen bg-[#0B0B0B] text-white font-sans" data-id="element-3774" data-mp="2w8liueidwzpm">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8 space-y-6" data-id="element-3775" data-mp="3a58pj905348q">
        <DriverAdminTabs data-id="element-3776" data-mp="35804n0nlwm3s" />

        {/* Header */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-3777" data-mp="35548nhvbk7hz">
          <div className="flex items-center gap-3" data-id="element-3778" data-mp="2hf9rwp7vpysg">
            <div className="w-12 h-12 bg-[#141414] border border-white/10 rounded-2xl flex items-center justify-center" data-id="element-3779" data-mp="2dgsnwejr94f9">
              <Users className="w-6 h-6 text-[#006847]" data-id="element-3780" data-mp="2r8qog0zehrzt" />
            </div>
            <div data-id="element-3781" data-mp="2mfed2sjqfhp0">
              <h1 className="text-2xl font-bold" data-id="element-3782" data-mp="2mew9fauqq172">Conductores</h1>
              <p className="text-white/40 text-sm" data-id="element-3783" data-mp="1yqd3h1z5y0i5">
                {drivers.length} registrados
              </p>
            </div>
          </div>
          <button onClick={() => navigate('/admin/drivers/new')} className="flex items-center justify-center gap-2 bg-[#006847] hover:bg-[#005a3d] text-white font-bold py-3 px-6 rounded-xl transition-all active:scale-95" data-id="element-3784" data-mp="1tri9r4znqrj9">
            <Plus className="w-5 h-5" data-id="element-3785" data-mp="9uesd2kg0to" />
            Nuevo Conductor
          </button>
        </div>

        {/* Search */}
        <div className="relative" data-id="element-3786" data-mp="58xhhqv2puyh">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-white/20" data-id="element-3787" data-mp="55rs0aij8r28" />
          <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Buscar por nombre o teléfono..." className="w-full bg-[#141414] border border-white/10 rounded-xl pl-12 pr-4 py-3.5 text-sm text-white placeholder:text-white/20 focus:outline-none focus:border-[#006847] focus:ring-1 focus:ring-[#006847]" data-id="element-3788" data-mp="svvycpn3v4wx" />
        </div>

        {/* List */}
        {loading ? <div className="flex justify-center py-20" data-id="element-3789" data-mp="38qfs2628dg2l">
            <Loader2 className="w-8 h-8 text-[#006847] animate-spin" data-id="element-3790" data-mp="3ny9i2elk5gh4" />
          </div> : filtered.length === 0 ? <div className="text-center py-20" data-id="element-3791" data-mp="3j6qbsh0utic7">
            <Car className="w-16 h-16 text-white/10 mx-auto mb-4" data-id="element-3792" data-mp="3j5yf12vitekc" />
            <p className="text-white/40 text-lg font-medium" data-id="element-3793" data-mp="3f6pmg1c7vmqd">
              {search ? 'Sin resultados' : 'No hay conductores registrados'}
            </p>
          </div> : <div className="space-y-3" data-id="element-3794" data-mp="aqyac3f09isa">
            {filtered.map(driver => <div key={driver.id} className="bg-[#141414] border border-white/10 rounded-2xl p-5 flex flex-col sm:flex-row sm:items-center gap-4" data-id="element-3795" data-mp="6puwfmgipwtp">
                {/* Avatar + Info */}
                <div className="flex items-center gap-4 flex-1 min-w-0" data-id="element-3796" data-mp="3sx2t80ddgve4">
                  <div className="w-12 h-12 bg-white/5 rounded-full flex items-center justify-center shrink-0 text-xl font-black text-white/30" data-id="element-3797" data-mp="2mhseos5mt8bv">
                    {driver.full_name?.charAt(0)?.toUpperCase() || '?'}
                  </div>
                  <div className="min-w-0" data-id="element-3798" data-mp="27gbrzlnhakfw">
                    <h3 className="font-bold text-white truncate" data-id="element-3799" data-mp="2cd2bkiyhry62">
                      {driver.full_name}
                    </h3>
                    <div className="flex items-center gap-3 text-sm text-white/50 mt-1 flex-wrap" data-id="element-3800" data-mp="2hbwtliomxip4">
                      {driver.national_id && <span className="flex items-center gap-1" data-id="element-3801" data-mp="2q50a5zukubnz">
                          <IdCard className="w-3 h-3" data-id="element-3802" data-mp="2q4qi86pz1ufn" />
                          {driver.national_id}
                        </span>}
                      <span className="flex items-center gap-1" data-id="element-3803" data-mp="302wn8x72rgoq">
                        <Phone className="w-3 h-3" data-id="element-3804" data-mp="35296z92ng7n3" />
                        {driver.phone}
                      </span>
                      {driver.active_vehicle ? <span className="flex items-center gap-1.5 bg-[#006847]/20 text-[#00a870] px-2.5 py-0.5 rounded-lg font-medium" data-id="element-3805" data-mp="15qzoej6az8jn">
                          <Car className="w-3 h-3" data-id="element-3806" data-mp="12nadete4rzj3" />
                          {driver.active_vehicle.plate} (
                          {driver.active_vehicle.vehicle_type})
                        </span> : <span className="flex items-center gap-1.5 bg-white/5 text-white/40 px-2.5 py-0.5 rounded-lg font-medium" data-id="element-3807" data-mp="1cmrf6zq9ht9s">
                          <Car className="w-3 h-3" data-id="element-3808" data-mp="17opzmos1oc32" />
                          Sin vehículo
                        </span>}
                    </div>
                  </div>
                </div>

                {/* Status + Actions */}
                <div className="flex items-center gap-3 shrink-0 mt-4 sm:mt-0" data-id="element-3809" data-mp="1vchcbthhyr4v">
                  <button onClick={() => navigate('/admin/assignments')} className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold bg-white/5 text-white/70 hover:bg-white/10 transition-colors" data-id="element-3810" data-mp="1qdediqs41h5c">
                    <LinkIcon className="w-3.5 h-3.5" data-id="element-3811" data-mp="209hj66m67xx1" /> Asignar
                  </button>
                  <button onClick={() => toggleActive(driver.id, driver.is_active)} className={`flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold transition-colors ${driver.is_active ? 'bg-[#006847]/20 text-[#00a870] hover:bg-[#006847]/30' : 'bg-red-500/10 text-red-400 hover:bg-red-500/20'}`} data-id="element-3812" data-mp="2ixi74ank8qa1">
                    {driver.is_active ? <>
                        <CheckCircle2 className="w-3.5 h-3.5" data-id="element-3813" data-mp="250d2mf3hvzgw" /> Activo
                      </> : <>
                        <XCircle className="w-3.5 h-3.5" data-id="element-3814" data-mp="1ra9n06z4f40f" /> Inactivo
                      </>}
                  </button>
                </div>
              </div>)}
          </div>}
      </div>
    </div>;
}